import { createApp, type App } from 'vue';
import AntDesignVue from 'ant-design-vue';
import ManagerReports from './index.vue';

const MOUNT_ID = 'lkManagerReportsApp';

let managerReportsApp: App<Element> | null = null;
let currentMountEl: HTMLElement | null = null;

export function initManagerReports(root?: ParentNode): void {
  const mountEl = root
    ? (root.querySelector<HTMLElement>(`#${MOUNT_ID}`) ?? document.getElementById(MOUNT_ID))
    : document.getElementById(MOUNT_ID);

  if (!mountEl) {
    return;
  }

  if (managerReportsApp && currentMountEl) {
    managerReportsApp.unmount();
    currentMountEl.innerHTML = '';
  }

  const app = createApp(ManagerReports);
  app.use(AntDesignVue);
  app.mount(mountEl);

  managerReportsApp = app;
  currentMountEl = mountEl;
}
